import type { FC } from 'react'
import React from 'react'

import NumberBadge from '@vfuk/core-number-badge'

import type { IconSafeZoneProps } from './IconSafeZone.types'
import * as Styled from './styles/IconSafeZone.style'

import { nonThemeableRules } from '../../ruleSet'

const IconSafeZone: FC<IconSafeZoneProps> = ({
  size = nonThemeableRules.defaultSize as number as IconSafeZoneProps['size'],
  isResponsive = false,
  appearance = 'primary',
  inverse = false,
  state,
  numberBadge,
}: IconSafeZoneProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive} appearance={appearance} inverse={inverse} state={state}>
      <svg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'>
        <g fill='none'>
          <path
            d='M14.578 9.105a2.579 2.579 0 1 1-5.156 0A2.576 2.576 0 0 1 12 6.527a2.576 2.576 0 0 1 2.578 2.578Zm0 0'
            vectorEffect='non-scaling-stroke'
          />
          <path
            d='M11.973 3.566a5.553 5.553 0 0 1 5.558 5.547c0 3.684-5.535 8.453-5.535 8.453S6.47 12.781 6.47 9.094A5.526 5.526 0 0 1 12 3.566'
            vectorEffect='non-scaling-stroke'
          />
          <path
            d='M15.313 14.227c3.582.468 6.132 1.68 6.132 3.093 0 1.825-4.23 3.305-9.445 3.305s-9.453-1.48-9.453-3.3c0-1.438 2.625-2.66 6.285-3.118'
            vectorEffect='non-scaling-stroke'
          />
        </g>
      </svg>
      <If condition={numberBadge}>
        <Styled.NumberBadgeContainer>
          <NumberBadge number={numberBadge!} appearance={inverse ? appearance : 'primary'} />
        </Styled.NumberBadgeContainer>
      </If>
    </Styled.IconWrapper>
  )
}

export default IconSafeZone
